import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useTimezone } from '@/hooks';
import { FULL_WEEKDAY_MONTH_YEAR_HOUR_DATE_FORMAT } from '@/config/variables';

interface IProps {
  item?: {
    dateCreated: string;
    createdByName: string;
    dateModified: string | null;
    modifiedByName: string | null;
  };
}

const ResourceMetadataSection = ({ item }: IProps): React.ReactElement => {
  const { formatDateTime } = useTimezone();
  const { t } = useTranslation();

  if (!item) return <></>;

  return (
    <Section>
      <p>
        {t('resources.modals.metadata.createdOn', {
          date: formatDateTime(item.dateCreated, FULL_WEEKDAY_MONTH_YEAR_HOUR_DATE_FORMAT),
          user: item.createdByName.replace('.', ' '),
        })}
      </p>
      {item.dateModified && (
        <p>
          {t('resources.modals.metadata.modifiedOn', {
            date: formatDateTime(item.dateModified, FULL_WEEKDAY_MONTH_YEAR_HOUR_DATE_FORMAT),
            user: item.modifiedByName?.replace('.', ' '),
          })}
        </p>
      )}
    </Section>
  );
};

export { ResourceMetadataSection };

const Section = styled.div`
  p {
    margin: 0;
    font-size: 12px;
  }
`;
